import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import { addEventListener } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';
import Header from './header/';
import Content from './content/';
import BottomFooter from './bottomFooter';
import Affix from './affix';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();

        this.unHandleClick = addEventListener(document, 'click', this.handleClick);
    }

    componentWillUnmount() {
        this.unHandleClick();
    }

    // 全站渠道标记传递，文章页的任意跳转
    handleClick = e => {
        const tag = this.getATag(e.target);

        if (!tag) return;

        let localHref =
            (tag.attributes['sign-trs-href'] ? tag.attributes['sign-trs-href'].value : '') ||
            (tag.attributes['href'] ? tag.attributes['href'].value : '');

        if (
            localHref &&
            localHref !== 'undefined' &&
            localHref !== '' &&
            localHref !== '#' &&
            localHref.indexOf('javascript:') === -1
        ) {
            localHref = localHref.trim();
            const localSearch = location.search;
            const localHash = location.hash;

            tag.setAttribute('sign-trs-href', localHref);

            let newUrl = '';
            let inWhitelist = false;
            const whitelist = ['//dol.deliver.ifeng.com/'];

            for (let i = 0, len = whitelist.length; i < len; i++) {
                if (localHref.indexOf(whitelist[i]) > -1) {
                    inWhitelist = true;
                }
            }
            // 传递下划线开头的统计
            const curSrc = this.getParam(localSearch, localHash);

            if ((localSearch || localHash) && curSrc && !inWhitelist) {
                if (localHref.indexOf('?') > -1) {
                    newUrl = `${localHref}&${curSrc}`;
                } else {
                    newUrl = `${localHref}?${curSrc}`;
                }

                tag.setAttribute('href', newUrl);
            }
        }
    };

    getATag = tag => {
        if (!tag) {
            return null;
        }

        if (tag.tagName !== 'A') {
            return this.getATag(tag.parentElement);
        } else {
            return tag;
        }
    };

    getSign = (localSearch, ret) => {
        const localSearchArr = localSearch.split('#');

        for (let i = 0; i < localSearchArr.length; i++) {
            const localParam = localSearchArr[i];

            if (localParam.indexOf('_') === -1) continue;

            const localParamArr = localParam.split('?');

            for (let j = 0; j < localParamArr.length; j++) {
                const localParam2 = localParamArr[j];

                if (localParam2.indexOf('_') === -1) continue;

                const localParam2Arr = localParam2.split('&');

                for (let m = 0; m < localParam2Arr.length; m++) {
                    const localParam3 = localParam2Arr[m];

                    if (localParam3.indexOf('_') === -1) continue;

                    const localParam3Arr = localParam3.split('|');

                    for (let k = 0; k < localParam3Arr.length; k++) {
                        const localParam4 = localParam3Arr[k];

                        if (localParam4.indexOf('_') !== 0) continue;

                        if (ret === '') {
                            ret += localParam4;
                        } else {
                            ret = `${ret}&${localParam4}`;
                        }
                    }
                }
            }
        }

        return ret;
    };

    getParam = (localSearch, localHash) => {
        let ret = '';

        if (localSearch.indexOf('_zbs') > -1) {
            ret = this.getSign(localSearch, ret);
        }
        if (localHash.indexOf('_zbs') > -1) {
            ret = this.getSign(localHash, ret);
        }

        return ret;
    };

    render() {
        const { content } = this.props;
        const {
            docData,
            docData: { logo, domain, breadCrumbdata, title, commentUrl, searchPath },
            nav,
            search,
            goodbook0,
            goodbook1,
            article,
            video,
            qrCodeSet,
            welfare,
            wireless,
            ppxAd: { page_ppposiiton_live1, page_ppposiiton_live2, page_ppposiiton_live3 },
            logoPPX,
            asidePPX,
            commentPPX,
            adMap,
            topAd,
            logoAd,
            contentAd,
            infoAd,
            hardAd,
            serviceAd,
            contentBottomAd,
            articleAd,
            videoAd,
            asideAd1,
            asideAd2,
            asideAd3,
            asideAd4,
            asideAd5,
            asideAd6,
            bottomAd,
            footer,
            floatAd1,
            floatAd2,
        } = content;

        const headerData = {
            nav,
            search,
            adMap,
            topAd,
            logoAd,
            logoPPX,
            logo,
            domain,
            breadCrumbdata,
        };
        const contentData = {
            leftContentData: {
                article: docData,
                page_ppposiiton_live3,
                commentPPX,
                goodbook0,
                contentAd,
                infoAd,
                hardAd,
                serviceAd,
                contentBottomAd,
            },
            rightContentData: {
                searchPath,
                article,
                video,
                qrCodeSet,
                welfare,
                wireless,
                goodbook1,
                page_ppposiiton_live1,
                page_ppposiiton_live2,
                articleAd,
                videoAd,
                asideAd1,
                asideAd2,
                asidePPX,
                asideAd3,
                asideAd4,
                asideAd5,
                asideAd6,
            },
        };
        const footerData = { bottomAd, footer };

        const ppxAd1 = page_ppposiiton_live1 ? page_ppposiiton_live1 : [];
        const ppxAd2 = page_ppposiiton_live2 ? page_ppposiiton_live2 : [];
        const ppxAd3 = page_ppposiiton_live3 ? page_ppposiiton_live3 : [];

        const affixData = {
            ppxAd: [...ppxAd1, ...ppxAd2, ...ppxAd3],
            title,
            commentUrl,
            floatAd1,
            floatAd2,
        };

        return (
            <div>
                <Header content={headerData} />
                <div className={styles.space40} />
                <Content content={contentData} />
                <div className={styles.space10} />
                <BottomFooter content={footerData} />
                <Affix content={affixData} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
